import React, { useEffect, useState } from "react";
import { Modal, Button, Card, Form } from "react-bootstrap";
import { LiaIdCard } from "react-icons/lia";
import { FaUpload } from "react-icons/fa6";

import Swal from "sweetalert2";
import { fetchClientData } from "../../../../redux/client/clientSlice";
import { useDispatch } from "react-redux";
import { FaTrash } from "react-icons/fa";
import api from "../../../../utils/api";
import socket from "../../../../context/socket";

const AddressProofTypeModal = ({
  show,
  onHide,
  onSave,
  roomId,
  kycDoc,
  selectedProofType,
  setSelectedProofType,
  clientData,
}) => {
  // console.log("kl", clientData?.kyc_info?.is_kyc_done !== "yes");
  const [frontImage, setFrontImage] = useState(null);
  const [backImage, setBackImage] = useState(null);
  const [clientAddressProof, setClientAddressProof] = useState([]);
  const [previewPassportFrontUrl, setPreviewPassportFrontUrl] = useState(null);
  const [previewPassportBackUrl, setPreviewPassportBackUrl] = useState(null);
  const [uploadLoading, setUploadLoading] = useState(false);

  const dispatch = useDispatch();
  console.log("kycDoc", kycDoc);

  useEffect(() => {
    if (
      (selectedProofType === "dl" || selectedProofType === "aadhaar") &&
      clientData?.kyc_info?.is_kyc_done !== "yes"
    ) {
      userKycTroughDigilocker(selectedProofType);
    }
  }, [selectedProofType]);

  const userKycTroughDigilocker = async (doctypee) => {
    console.log("doctype", doctypee);
    const client_id = roomId;
    const doctype = doctypee === "dl" ? "DRV" : "ADH";

    try {
      Swal.fire({
        text: "Please wait...",
        imageUrl: "https://www.finedge.in/assets/images/download.gif",
        imageWidth: 100,
        imageHeight: 100,
        allowOutsideClick: false,
        showConfirmButton: false,
      });

      const response = await api.post(
        `advisor/initiateDigilocker`,
        { client_id, doctype }
      );

      Swal.close();

      console.log("response:", response?.data);

      if (
        response?.data.status === "success" &&
        response?.data.param?.Vendor === "CAMS"
      ) {
        const params = response.data.param;
        digilocker(params);
      } else {
        Swal.fire({
          icon: "error",
          text: "DigiLocker session initiation failed or unsupported vendor.",
          confirmButtonText: "OK",
          customClass: {
            confirmButton: "swal-confirm-btn",
          },
        }).then((result) => {
          if (result.isConfirmed) {
            onHide();

          }
        });
      }
    } catch (error) {
      Swal.close();
      console.error("Error fetching data:", error);

      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Server error. Please try again later.",
        confirmButtonText: "OK",
        customClass: {
          confirmButton: "swal-confirm-btn",
        },
      }).then((result) => {
        if (result.isConfirmed) {
          onHide();
        }
      });
    }
  };

  //  Function to create and submit hidden form to CAMS DigiLocker
  function digilocker(response) {
    const form = document.createElement("form");
    form.method = "POST";
    form.enctype = "multipart/form-data";
    form.action =
      "https://digitalapiuat.camsonline.com/CAMSDigiLocker/CDLHome/HomeScreen";
    form.style.display = "none";
    form.target = "digilocker";

    const tempParam = {
      ClientID: "CAMS_FINEDGE_CLIENT",
      ClientSecret: "s3nEBei3XT$sec0XxWTD",
      SessionID: response.SessionID,
      ReturnURL: response.ReturnURL,
      Key: response.Key,
      Data: response.Data,
      Hash: response.Hash,
    };

    form.appendChild(createHiddenInput("param", JSON.stringify(tempParam)));
    document.body.appendChild(form);

    const popupWindow = window.open("", "digilocker", "width=800,height=600");
    form.target = popupWindow.name;
    form.submit();
  }

  //  Helper function to create hidden input fields
  function createHiddenInput(name, value) {
    const input = document.createElement("input");
    input.type = "hidden";
    input.name = name;
    input.value = value;
    return input;
  }

  const filterAddressProof = (kycDocList, selectedType) => {
    if (Array.isArray(kycDocList)) {
      return kycDocList.filter((item) => item.doctype === selectedType);
    }
    return [];
  };

  useEffect(() => {
    const filtered = filterAddressProof(kycDoc, selectedProofType);
    console.log("filtered", filtered);
    setClientAddressProof(filtered);
  }, [selectedProofType, clientData]);

  console.log("clientAddressProof for my checkup", clientAddressProof);
  console.log("clientAddressProof for my checkup", kycDoc);

  console.log(
    clientAddressProof[0]?.sinzey_doc_url_front,
    "clientAddressProof"
  );
  useEffect(() => {
    if (clientAddressProof[0]?.sinzey_doc_url_front) {
      setIsFrontImageUploaded(true);
    }
  }, [clientAddressProof]);

  console.log("clientAddressProof", clientAddressProof);

  const handleCardClick = (proofType) => {
    if (selectedProofType === null) {
      setSelectedProofType(proofType);
    }
  };
  const [isFrontImageUploaded, setIsFrontImageUploaded] = useState(false);
  const [uploadStatusFront, setUploadStatusFront] = useState("");
  const [uploadStatusBack, setUploadStatusBack] = useState("");
  const [frontUrl, setFrontUrl] = useState("");
  const [backUrl, setBackUrl] = useState("");


  useEffect(() => {
    const front = clientAddressProof?.[0]?.fin_doc_url_front || "";
    const back = clientAddressProof?.[0]?.fin_doc_url_back || "";
    setFrontUrl(front);
    setBackUrl(back);
  }, [clientAddressProof]);



  // console.log("isFrontImageUploaded", isFrontImageUploaded, frontImage)

  const handleFrontImageChange = async (e) => {
    setFrontImage(e.target.files[0]);
    const formData = new FormData();
    formData.append("_id", roomId);
    formData.append("document_type", selectedProofType);
    formData.append("documentfile", e.target.files[0]);
    formData.append("label", "front");
    setUploadStatusFront("uploading");
    try {
      // Send POST request
      const response = await api.post(
       "advisor/cams_upload_kyc_document",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      console.log(
        "response Addres proof FrontImage uploading files:",
        response
      );
      setIsFrontImageUploaded(true);
      setUploadStatusFront("success");
      dispatch(fetchClientData(roomId));

      const updatedKycDoc = [...clientData?.kyc_doc]; // get fresh reference from updated props
      const filtered = filterAddressProof(updatedKycDoc, selectedProofType);
      setClientAddressProof(filtered);


      // setSelectedProofType(null);

      // Call onSave callback
      // onSave({ selectedProofType, frontImage, backImage });
      // onHide();
    } catch (error) {
      setUploadStatusFront("error");
      console.error("Error uploading files:", error);
    }
  };

  const handleBackImageChange = async (e) => {
    setBackImage(e.target.files[0]);
    const formData = new FormData();
    formData.append("_id", roomId);
    formData.append("document_type", selectedProofType);
    formData.append("documentfile", e.target.files[0]);
    formData.append("label", "back");
    setUploadStatusBack("uploading");
    try {
      // Send POST request
      const response = await api.post(
       "advisor/cams_upload_kyc_document",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      console.log("response uploading files:", response);
      setUploadStatusBack("success");
      dispatch(fetchClientData(roomId));

      // setSelectedProofType(null);

      // Call onSave callback
      // onSave({ selectedProofType, frontImage, backImage });
      // onHide();
    } catch (error) {
      setUploadStatusBack("error");
      console.error("Error uploading files:", error);
    }
  };

  const isUploadDisabled = !(
    // previewPassportFrontUrl ||
    (selectedProofType === "passport" ? frontImage : frontImage && backImage)
  );

  console.log("isUploadDisabled", isUploadDisabled);

  const handleSave = async () => {
    setUploadLoading(true);
    Swal.fire({
      title: "Loading Address Proof Data",
      //text: "Please wait...",
      imageUrl: "https://www.finedge.in/assets/images/download.gif",
      showConfirmButton: false,
      allowOutsideClick: false,
      allowEscapeKey: false,
    });
    if (!isUploadDisabled) {
      const allData = {
        client_id: roomId,
        documenttype: selectedProofType,
        // action: "execute",
      };

      try {
        // Send the first POST request
        const response = await api.post(
          `advisor/verifyKycDocuments`,
          allData
        );

        console.log("severifyKycDocuments:", response);
        if (response.data.status === "success") {
          Swal.fire({
            icon: "success",
            text: response.data.message,
            confirmButtonText: "OK",
            customClass: {
              confirmButton: "swal-confirm-btn",
            },
          }).then(() => {
            onHide();
            setFrontImage(null);
            setBackImage(null);
            dispatch(fetchClientData(roomId));
      
            socket.emit("join", { room: roomId });
            socket.emit("message_to", 
              {
                room: roomId,
                data: { message: response?.message || "Client data updated successfully",
                type: "success",}
              
              })
            console.log("emitted data message_to", roomId, "success");
          });
          setFrontImage(null);
          setUploadLoading(false);
        } else {
          Swal.fire({
            icon: "error",
            title: "Upload Failed",
            text:
              response?.data?.message ||
              "Something went wrong during verification.",
            confirmButtonText: "OK",
            customClass: {
              confirmButton: "swal-confirm-btn",
            },
          });
          setUploadLoading(false);
        }
      } catch (error) {
        console.error(
          "Error during file upload process:",
          error.response?.data || error.message
        );

        console.error(
          "Error during file upload process:",
          error.response?.data || error.message
        );

        Swal.fire({
          icon: "error",
          title: "Upload Failed",
          text:
            error?.response?.data?.message ||
            "Something went wrong during verification.",
          confirmButtonText: "OK",
          customClass: {
            confirmButton: "swal-confirm-btn",
          },
        });
      }
    }
  };

  const cardStyle = (type) => ({
    backgroundColor: selectedProofType === type ? "#d4edda" : "#fff",
    textTransform: "capitalize",
    // cursor: selectedProofType ? "pointer" : "not-allowed",
    opacity: selectedProofType && selectedProofType !== type ? 0.5 : 1,
  });

  useEffect(() => {
    setPreviewPassportFrontUrl(clientAddressProof?.[0]?.fin_doc_url_front);
    console.log(
      "clientAddressProof",
      clientAddressProof?.[0]?.fin_doc_url_front
    );
  }, [kycDoc, clientAddressProof]);

  const uploadedProofs = kycDoc?.map((doc) => doc.doctype).filter(Boolean); // Remove nulls

  const handleDelete = (label) => {
    if (label === "front") {
      setFrontImage(null);
      setFrontUrl(""); // clear backend image as well
    } else if (label === "back") {
      setBackImage(null);
      setBackUrl(""); // clear backend image
    }
  };


  return (
    <>
      <Modal size={"lg"} centered show={show} onHide={onHide}>
        <Modal.Header closeButton style={{ backgroundColor: "#fff" }}>
          <Modal.Title className="fw-normal">
            Select Address Proof Type
          </Modal.Title>
        </Modal.Header>
        <Modal.Body closeButton>
          <div className="d-flex justify-content-between gap-1 align-items-center">
            {["passport", "voterid", "dl", "aadhaar"].map((type) => {
              const isUploaded = uploadedProofs?.includes(type);
              return (
                <Card
                  key={type}
                  className={`border-1 text-center w-100 ${isUploaded ? "bg-success text-white" : ""
                    }`}
                  style={cardStyle(type)}
                  onClick={() => handleCardClick(type)}
                >
                  <Card.Body style={{ cursor: "pointer" }}>
                    <p
                      className={`fw-normal fs-2 capitalize refer ${isUploaded ? "text-white" : ""
                        }`}
                    >
                      {type}
                    </p>
                  </Card.Body>
                </Card>
              );
            })}
          </div>

          {selectedProofType === null && (
            <>
              {clientAddressProof.length > 0 &&
                clientAddressProof[0].sinzey_doc_url_front && (
                  <div>
                    <h5 className="text-success text-center">
                      Uploaded Address Proof
                    </h5>
                    <div className="d-flex justify-content-between mb-4">
                      <Card className="upload-card">
                        <Card.Body>
                          <Card.Img
                            variant="top"
                            src={clientAddressProof[0].sinzey_doc_url_front}
                            alt="Front Image"
                            className="w-100"
                          />
                        </Card.Body>
                        <Card.Footer>First Page</Card.Footer>
                      </Card>
                      <Card className="upload-card">
                        <Card.Body>
                          <Card.Img
                            variant="top"
                            src={clientAddressProof[0].sinzey_doc_url_back}
                            alt="Back Image"
                            className="w-100"
                          />
                        </Card.Body>
                        <Card.Footer>Last Page</Card.Footer>
                      </Card>
                    </div>
                  </div>
                )}
            </>
          )}
          {/* in aadhaar and  dl  if kyc done  then show upload otion and dont show  */}
          {(selectedProofType === "passport" ||
            selectedProofType === "voterid" ||
            ((selectedProofType === "dl" || selectedProofType === "aadhaar") &&
              clientData?.kyc_info?.is_kyc_done === "yes")) && (
              <div className="mt-4">
                <h5 className="text-success text-center">
                  Upload {selectedProofType}
                </h5>

                <div className="d-flex justify-content-between my-2">
                  {/* Front Image */}
                  {(frontImage ||
                    frontUrl) && (
                      <img
                        src={
                          frontImage
                            ? URL.createObjectURL(frontImage)
                            : previewPassportFrontUrl &&
                              selectedProofType === "passport"
                              ? previewPassportFrontUrl
                              : frontUrl
                        }
                        alt={`${selectedProofType} front`}
                        style={{ width: "45%" }}
                      />
                    )}

                  {/* Back Image (only for voterid) */}
                  {(backImage ||
                  backUrl) && (
                      <img
                        src={
                          backImage
                            ? URL.createObjectURL(backImage)
                            : backUrl
                        }
                        alt={`${selectedProofType} back`}
                        style={{ width: "45%" }}
                      />
                    )}
                </div>

                <div className="d-flex justify-content-between">
                  {(frontImage || frontUrl) ? (
                    <button
                      onClick={() => handleDelete("front")}
                      className="btn btn-outline-danger d-flex align-items-center justify-content-center p-0"
                      title="Delete"
                      style={{ width: "36px", height: "36px" }}
                    >
                      <FaTrash size={18} />
                    </button>
                  ) : (
                    <Card className="upload-card">
                      <FaUpload
                        className="text-success "
                        style={{ position: "relative", top: "35px" }}
                      />
                      <label htmlFor="frontImage" className="upload-label pb-5">
                        {selectedProofType === "passport"
                          ? "First Page"
                          : "Front Page"}
                        <Form.Control
                          id="frontImage"
                          type="file"
                          accept="image/*"
                          onChange={handleFrontImageChange}
                          style={{ display: "none" }}
                        />
                        {frontImage && (
                          <span className="uploaded-text">{frontImage.name}</span>
                        )}
                      </label>
                      <p className="upload-status mt-2">
                        {uploadStatusFront === "uploading" && "Uploading..."}
                        {uploadStatusFront === "success" && "Upload successful!"}
                        {uploadStatusFront === "error" &&
                          "Upload failed. Try again."}
                      </p>
                    </Card>
                  )}
                  {selectedProofType !== "passport" &&
                    <>
                      {(backImage ||
                        backUrl) ? (<button
                          onClick={() => handleDelete("back")}
                          className="btn btn-outline-danger d-flex align-items-center justify-content-center p-0"
                          title="Delete"
                          style={{ width: "36px", height: "36px" }}
                        >
                          <FaTrash size={18} />
                        </button>
                      ) : (
                        <Card
                          className="upload-card"
                          // disabled={
                          //   selectedProofType === "passport"
                          //     ? true
                          //     : !isFrontImageUploaded
                          // }
                          style={{
                            backgroundColor:
                              !frontImage && !frontUrl

                                ? "lightgray"
                                : "",
                            pointerEvents:
                              !frontImage && !frontUrl

                                ? "none"
                                : "auto",
                            opacity:
                              !frontImage && !frontUrl

                                ? 0.5
                                : 1,
                          }}
                        >
                          <FaUpload
                            className="text-success "
                            style={{ position: "relative", top: "35px" }}
                          />
                          <label htmlFor="backImage" className="upload-label pb-5">
                            {selectedProofType === "passport"
                              ? "Last Page"
                              : "Back Page"}
                            <Form.Control
                              id="backImage"
                              type="file"
                              accept="image/*"
                              onChange={handleBackImageChange}
                              style={{ display: "none" }}
                              disabled={
                                selectedProofType === "passport"
                                  ? true
                                  : !frontImage && !frontUrl


                              }
                            />
                            {backImage && (
                              <span className="uploaded-text">{backImage.name}</span>
                            )}
                          </label>
                          <p className="upload-status mt-2">
                            {uploadStatusBack === "uploading" && "Uploading..."}
                            {uploadStatusBack === "success" && "Upload successful!"}
                            {uploadStatusBack === "error" &&
                              "Upload failed. Try again."}
                          </p>
                        </Card>
                      )}
                    </>
                  }
                </div>
              </div>
            )}
          {/* {selectedProofType==="dl"||selectedProofType=== "aadhaar" &&

          } */}
        </Modal.Body>
        <Modal.Footer style={{ backgroundColor: "#f0f0f0" }}>
          {selectedProofType ? (
            <>
              <Button
                variant="secondary"
                onClick={() => {
                  setSelectedProofType(null);
                  setFrontImage(null);
                }}
              >
                Back
              </Button>
              <Button
                variant="success"
                onClick={handleSave}
                disabled={isUploadDisabled}
              >
                Upload
              </Button>
            </>
          ) : (
            <></>
            // <Button variant="secondary" onClick={onHide}>
            //   Close
            // </Button>
          )}
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default AddressProofTypeModal;
